exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bi-common-color-ranged-number__c1{color:#00aa5e}.bi-common-color-ranged-number__c2{color:#ffb000}.bi-common-color-ranged-number__c3{color:#e62325}", ""]);

// exports
